import { borderRadius } from './border-radius';
import { colors, colorsV2 } from './colors';
import { font, fontSize } from './font';
import { shadows } from './shadows';
import { spacing, GRID_UNIT } from './spacing';
import { zIndex } from './z-index';

export { GRID_UNIT };

// The JS values of the theme, as opposed to CSS vars
export const weaveTheme = {
  borderRadius,
  colors,
  colorsV2,
  font,
  fontSize,
  heightOffset: 0,
  name: 'spark',
  shadows,
  spacing,
  zIndex,
} as const;

export type WeaveTheme = typeof weaveTheme;
